import { useCallback, useMemo, useState } from "react";

export function useChildSectionState(keys: string[]) {
  const [openState, setOpenState] = useState<Record<string, boolean>>({});

  const allOpen = useMemo(
    () => keys.length > 0 && keys.every((k) => openState[k]),
    [keys, openState],
  );

  const toggle = useCallback((key: string) => {
    setOpenState((prev) => ({ ...prev, [key]: !prev[key] }));
  }, []);

  const toggleAll = useCallback(() => {
    const nextOpen = !allOpen;
    setOpenState(Object.fromEntries(keys.map((k) => [k, nextOpen])));
  }, [allOpen, keys]);

  return { openState, allOpen, toggle, toggleAll };
}
